import { Link } from '@chakra-ui/react'
import styled from '@emotion/styled'
import Image from 'next/image'
import type { ReactNode, VFC } from 'react'

import CommonMeta from '../head/commonMeta'

export type SkyOnlyLayoutProps = {
    children: ReactNode
}

const spWidth = 599
const pcWidth = 1024

const Bg = styled.main`
    background: url(/images/bg-maker.png) no-repeat center;
    background-size: cover;
    width: 100vw;
    height: 100vh;
    background-attachment: local;
    position: relative;
    overflow: hidden;
`

const Footer = styled.footer`
    text-align: center;
    font-size: 0.92rem;
    font-weight: bold;
    color: #05151f;
    letter-spacing: 0.1em;
    width: 100vw;
    position: absolute;
    bottom: 4vh;
    @media (max-width: ${spWidth}px) {
        bottom: 2vh;
        font-size: 0.62rem;
        color: #ffffff;
    }
    @media (orientation: landscape) and (max-width: ${pcWidth}px) {
        bottom: 5vh;
        font-size: 0.62rem;
    }
`

const Stars = styled.div`
    position: absolute;
    top: -96%;
    left: 15%;
    height: 260vh;
    margin: auto;
    transform: rotate(45deg);
    width: 100vw;
`

const Star = styled.div`
    position: absolute;
    width: 1px;
    height: 80%;
    top: 0;
    left: 50%;

    &::after {
        content: '';
        display: block;
        position: absolute;
        height: 100vh;
        width: 100%;
        top: -60%;
        left: 0;
        background-color: #ffffff;
        animation: drop 6s 0s infinite;
        animation-fill-mode: forwards;
    }

    :first-of-type {
        margin-left: -45%;
        &::after {
            animation-delay: 1.2s;
        }
    }
    :nth-of-type(2) {
        margin-left: 12px;
        &::after {
            zoom: 0.5;
            animation-delay: -0.2s;
        }
    }
    :nth-of-type(3) {
        margin-left: -28%;
        &::after {
            animation-delay: 4.5s;
        }
    }
    :nth-of-type(4) {
        margin-left: 18%;
        &::after {
            animation-delay: 3.3s;
        }
    }
    :last-of-type {
        margin-left: 35%;
        &::after {
            animation-delay: 2.5s;
        }
    }

    @keyframes drop {
        0% {
            top: -45%;
            height: 100vw;
        }
        80% {
            height: 0;
        }
        100% {
            height: 0;
            top: 100%;
        }
    }
`

const AnimeTitle = styled.div`
    @media (orientation: landscape) and (max-width: ${pcWidth}px) {
        display: none;
    }
`

export const SkyOnlyLayout: VFC<SkyOnlyLayoutProps> = ({ children }) => {
    return (
        <Bg>
            <CommonMeta />
            <div className="relative w-screen h-[100vh] overflow-hidden">
                {children}
                <Stars>
                    <Star />
                    <Star />
                    <Star />
                    <Star />
                    <Star />
                    <Star />
                </Stars>
            </div>
            <AnimeTitle className="absolute md:w-5/6 w-3/6 max-w-sm md:h-[15vh] h-[18vw] top-[10vh] left-1/2 -translate-x-1/2 mx-auto">
                <Link href="/">
                    <Image src="/images/logo.svg" alt="惑星（ほし）のさみだれ" layout="fill" objectFit="contain" />
                </Link>
            </AnimeTitle>
            <Footer>
                <small>©水上悟志・少年画報社／ある時代の指輪の騎士団</small>
            </Footer>
        </Bg>
    )
}
